import ButtonSpinnerWhite from './ButtonSpinnerWhite';
import ButtonSpinnerUraniumBlue from './ButtonSpinnerUraniumBlue';
import ButtonSpinnerDisabledPurple from './ButtonSpinnerDisabledPurple';
import { type FormButtonVariant } from './../types';

interface ButtonSpinnerProps {
  variant: FormButtonVariant;
}

const ButtonSpinner = ({ variant }: ButtonSpinnerProps) => {
  const primaryVariants = ['primary', 'primary_small', 'primary_tiny'];
  const primaryDarkVariants = ['primary_dark', 'primary_dark_small', 'primary_dark_tiny'];
  const secondaryDarkVariants = ['secondary_dark', 'secondary_dark_small', 'secondary_dark_tiny'];
  const tertiaryDarkVariants = ['tertiary_dark', 'tertiary_dark_no_underline'];

  if (primaryVariants.includes(variant) || primaryDarkVariants.includes(variant)) {
    return <ButtonSpinnerWhite />;
  } else if (secondaryDarkVariants.includes(variant) || tertiaryDarkVariants.includes(variant)) {
    return <ButtonSpinnerDisabledPurple />;
  }
  return <ButtonSpinnerUraniumBlue />;
};

export default ButtonSpinner;
